"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactHelmet = _interopRequireDefault(require("react-helmet"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _button = _interopRequireDefault(require("../button"));

require("./wistia-button.less");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/**
 * Wistia Button for Wistia video Popovers.
 * For Wistia dev docs, see https://wistia.com/support/developers
 * ^ Warning, their dev docs are poorly organized.
 */
var WistiaButton = /*#__PURE__*/function (_Component) {
  _inherits(WistiaButton, _Component);

  var _super = _createSuper(WistiaButton);

  function WistiaButton() {
    var _this;

    _classCallCheck(this, WistiaButton);

    _this = _super.call(this);
    _this.timeout = null;
    _this.state = {
      includeWistia: false
    };
    _this.showPopover = _this.showPopover.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(WistiaButton, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      var shareLink = this.props.shareLink;
      var videoId = WistiaButton.getVideoId(shareLink);

      if (videoId) {
        /* eslint-disable no-underscore-dangle */
        // Add video to Wistia queue, store ref to it's video object
        window._wq = window._wq || [];

        window._wq.push({
          id: videoId,
          async: true,
          popover: true,
          popoverContent: 'link',
          onReady: function onReady(videoRef) {
            _this2.videoRef = videoRef;
          }
        });
        /* eslint-enable no-underscore-dangle */

      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var _this3 = this;

      if (this.videoRef) {
        this.videoRef.popover.hide();
        setTimeout(function () {
          return _this3.videoRef.remove();
        });
      }

      clearTimeout(this.timeout);
    }
    /**
     * After the video has loaded, we can interact with it via
     * Wistia's JS api
     */

  }, {
    key: "showPopover",
    value: function showPopover() {
      var _this4 = this;

      this.setState({
        includeWistia: true
      });
      clearTimeout(this.timeout);

      var playIfReady = function playIfReady() {
        if (_this4.videoRef) {
          _this4.videoRef.popover.show();

          setTimeout(function () {
            return _this4.videoRef.play();
          });
        } else {
          _this4.timeout = setTimeout(function () {
            return playIfReady();
          }, 50);
        }
      };

      playIfReady();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          buttonText = _this$props.buttonText,
          className = _this$props.className,
          preload = _this$props.preload,
          shareLink = _this$props.shareLink,
          size = _this$props.size,
          type = _this$props.type;
      var includeWistia = this.state.includeWistia;
      var isPlayButton = type === 'playButton';
      var buttonType = isPlayButton ? 'clearButton' : type;
      var icon = isPlayButton ? 'play-button' : 'play-circle';
      var text = isPlayButton ? null : buttonText;
      var videoId = WistiaButton.getVideoId(shareLink);
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _classnames["default"])('WistiaButton-wrapper', {
          playButton: isPlayButton
        })
      }, includeWistia ? /*#__PURE__*/_react["default"].createElement(_reactHelmet["default"], null, /*#__PURE__*/_react["default"].createElement("script", {
        src: "https://fast.wistia.com/assets/external/E-v1.js",
        type: "text/javascript",
        async: true
      })) : null, /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _classnames["default"])('wistia_embed', "wistia_async_".concat(videoId), 'popover=true', {
          'preload=true': preload
        })
      }), /*#__PURE__*/_react["default"].createElement(_button["default"], {
        icon: icon,
        onClick: this.showPopover,
        "aria-label": "Play Button for video: ".concat(buttonText),
        type: buttonType,
        size: size,
        className: (0, _classnames["default"])('WistiaButton', className, {
          playButton: isPlayButton
        })
      }, text));
    }
  }], [{
    key: "getVideoId",
    value:
    /**
     * Helper to extract the video id from a Wistia share link
     * Example format: https://glowforge.wistia.com/medias/xotlq75gkt
     * @param {String} shareLink Link from Wistia's share feature for a video
     */
    function getVideoId(shareLink) {
      // Regexp to extract the video id from a Wistia share url.\
      // The final group is the only one matched, and is in the [1] position.
      // Wistia provided this Regex
      var regexp = /https?:\/\/(?:.+)?(?:wistia\.com|wi\.st)\/(?:medias|embed)\/(.*)/;
      var groups = shareLink.match(regexp);
      return groups && groups[1];
    }
  }]);

  return WistiaButton;
}(_react.Component);

WistiaButton.propTypes = {
  buttonText: _propTypes["default"].string,
  className: _propTypes["default"].string,
  preload: _propTypes["default"].bool,
  shareLink: _propTypes["default"].string,
  size: _propTypes["default"].oneOf(['small', 'medium', 'large']),
  type: _propTypes["default"].oneOf(['text', 'default', 'primary', 'secondary'])
};
WistiaButton.defaultProps = {
  buttonText: '',
  className: '',
  preload: false,
  shareLink: '',
  size: 'medium',
  type: 'default'
};
var _default = WistiaButton;
exports["default"] = _default;